import SEO from "@/components/SEO";
import FAQAccordion from "@/components/FAQAccordion";
import { RelatedLinks } from "@/pages/ServicePage";
import { PageHero, SectionHead, CTABand, Reveal } from "@/components/Ui";

const etapes = [
  { n: "01", t: "Étude du projet", d: "Visite sur place, relevés, étude du terrain et devis détaillé gratuit." },
  { n: "02", t: "Préparation et fondations", d: "Terrassement, semelles et dalle béton adaptées au sol et au projet." },
  { n: "03", t: "Élévation des murs", d: "Montage des murs en parpaing, brique ou biobrique, avec linteaux et chaînages." },
  { n: "04", t: "Ouvertures et finitions", d: "Création des ouvertures, liaison avec l'existant et finitions selon la prestation." },
];

const faq = [
  { q: "Quels types d'extension réalisez-vous ?", a: "Agrandissements de maison, garages, carports et extensions maçonnées de toutes tailles, à Bernay, Évreux et dans l'Eure." },
  { q: "Prenez-vous en charge tout le gros œuvre ?", a: "Oui : étude, fondations, dalle, élévation des murs, ouvertures et raccordement au bâtiment existant." },
  { q: "Comment présenter mon projet d'extension ?", a: "Appelez-nous ou remplissez le formulaire de devis : nous venons étudier votre projet sur place, gratuitement." },
];

export default function ExtensionMaison() {
  return (
    <>
      <SEO
        title="Extension de maison à Bernay & dans l'Eure | DMZ Normandie"
        description="Extension et agrandissement de maison à Bernay, Évreux et dans l'Eure : étude, fondations, murs, dalles et ouvertures par DMZ Normandie. Devis gratuit."
        path="/extension-maison"
      />
      <PageHero
        title="Extension de maison"
        subtitle="Besoin de mètres carrés en plus ? DMZ Normandie construit votre extension, votre garage ou votre carport à Bernay et dans l'Eure : fondations, murs, dalles et ouvertures."
      />

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center mb-20">
            <Reveal>
              <SectionHead overline="Votre projet" title="Agrandir sans déménager" />
              <div className="-mt-6 space-y-5 text-zinc-400 font-light leading-relaxed">
                <p>
                  Une chambre supplémentaire, un garage, une véranda maçonnée ou un carport :
                  l'extension est souvent la solution la plus simple pour gagner de l'espace
                  sans quitter votre quartier.
                </p>
                <p>
                  Nous prenons en charge tout le gros œuvre : fondations, dalles, élévation des murs,
                  ouvertures et raccordement à l'existant. Vous avancez avec un interlocuteur unique
                  et un chantier tenu.
                </p>
                <p>
                  Avant de démarrer, nous étudions la faisabilité avec vous : emplacement au sol,
                  raccordement à la construction existante, nature du terrain et choix des matériaux.
                  Vous savez ainsi précisément ce qui sera réalisé, dans quel ordre et à quel prix.
                </p>
                <a href="/contact" className="btn-sable mt-4" data-testid="cta-presenter-projet">Présenter mon projet</a>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="overflow-hidden relative">
                <img src="/realisations/garage-carport.webp" alt="Extension de maison dans l'Eure : garage et carport construits par DMZ Normandie" className="w-full h-80 object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-black/25" />
              </div>
            </Reveal>
          </div>

          <SectionHead overline="Comment ça se passe" title="Les grandes étapes d'une extension" center />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {etapes.map((e, i) => (
              <Reveal key={e.n} delay={i * 0.06} className="card-dark p-8">
                <p className="font-serif-display font-light text-5xl text-[#C4A484] mb-5">{e.n}</p>
                <h3 className="font-medium text-[#F5F5F0] mb-3">{e.t}</h3>
                <p className="text-sm font-light text-zinc-500 leading-relaxed">{e.d}</p>
              </Reveal>
            ))}
          </div>

          <div className="max-w-4xl mx-auto mt-20">
            <SectionHead overline="Questions fréquentes" title="Vos questions, nos réponses" />
            <FAQAccordion items={faq} testid="faq-extension" />
          </div>

          <div className="mt-16">
            <Reveal>
              <p className="text-[10px] tracking-[0.5em] uppercase text-[#C4A484] mb-5">Voir aussi</p>
              <RelatedLinks slugs={["fondations", "maconnerie-bernay", "ouverture-mur-porteur", "renovation-bernay"]} />
            </Reveal>
          </div>
        </div>
      </section>

      <CTABand />
    </>
  );
}
